import React from "react";

const Star = ({ color = "currentColor" ,...props  }) => {
  if (props.filled) {
    return (
      <svg width="13" height="13" className="mx-[2px]" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.49986 10.2403L3.26944 12.7117C2.54389 13.2679 2.18071 12.9962 2.46183 12.0957L3.70493 8.11057L0.464755 5.65286C-0.263227 5.09998 -0.117793 4.65443 0.773498 4.65614L4.77253 4.66466L6.00018 0.674382C6.27643 -0.222663 6.72248 -0.226923 6.99954 0.674382L8.22638 4.66636L12.2262 4.65699C13.1248 4.65529 13.2581 5.10509 12.535 5.65371L9.29398 8.11142L10.5387 12.0966C10.8182 12.9928 10.4501 13.2637 9.73028 12.7125L6.49986 10.2412V10.2403Z" fill={color} />
      </svg>
      
      

    );
  }

  if(props.empty){
    return (
      <svg width="13" height="13" className="mx-[2px]" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.49986 10.2403L3.26944 12.7117C2.54389 13.2679 2.18071 12.9962 2.46183 12.0957L3.70493 8.11057L0.464755 5.65286C-0.263227 5.09998 -0.117793 4.65443 0.773498 4.65614L4.77253 4.66466L6.00018 0.674382C6.27643 -0.222663 6.72248 -0.226923 6.99954 0.674382L8.22638 4.66636L12.2262 4.65699C13.1248 4.65529 13.2581 5.10509 12.535 5.65371L9.29398 8.11142L10.5387 12.0966C10.8182 12.9928 10.4501 13.2637 9.73028 12.7125L6.49986 10.2412V10.2403Z" fill="transparent" />
      </svg>
      
      

    );
  }
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.15327 2.83977L10.3266 5.18643C10.4866 5.5131 10.9133 5.82643 11.2733 5.88643L13.3999 6.23977C14.7599 6.46643 15.0799 7.4531 14.0999 8.42643L12.4466 10.0798C12.1666 10.3598 12.0133 10.8998 12.0999 11.2864L12.5733 13.3331C12.9466 14.9531 12.0866 15.5798 10.6533 14.7331L8.65994 13.5531C8.29994 13.3398 7.70661 13.3398 7.33994 13.5531L5.34661 14.7331C3.91994 15.5798 3.05327 14.9464 3.42661 13.3331L3.89994 11.2864C3.98661 10.8998 3.83327 10.3598 3.55327 10.0798L1.89994 8.42643C0.926606 7.4531 1.23994 6.46643 2.59994 6.23977L4.72661 5.88643C5.07994 5.82643 5.50661 5.5131 5.66661 5.18643L6.83994 2.83977C7.47994 1.56643 8.51994 1.56643 9.15327 2.83977Z" stroke="#1C1C28" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export default Star;
